/* DAILYREPORT */
export const DAILYREPORT_LIST = 'DAILYREPORT_LIST';
export const DAILYREPORT_LIST_SUCCESS = 'DAILYREPORT_LIST_SUCCESS';
export const DAILYREPORT_LIST_FAILED = 'DAILYREPORT_LIST_FAILED';


